import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox } from '@/_components';

import { useGetPartnersMutation } from '../apis';
import type { PartnerQueryLinkerSchema } from '../schemas';

export function PartnersMultiSelect(props: FormAsyncComboboxProps<PartnerQueryLinkerSchema, true>) {
  return (
    <FormAsyncCombobox
      {...props}
      isMulti
      showBorder
      itemToString={(item) => item.name}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      getMultiValueLabel={(item) => item.name}
      useApi={useGetPartnersMutation}
    />
  );
}
